const REGION_HIERARCHY = [
    'Chest',
    'WL Chest',
    'Chest Pocket',
    'Front',
    'Back',
    'WR Sleeve',
    'WL Sleeve',
    'Nape',
    'WL Hip',
    'WR Hip',
    'WL Hem',
    'WR Hem',
    'Back Neck Label',
];
const fit = (imageSize, targetSize) => {
    if (imageSize.x === 0 || imageSize.y === 0)
        return Object.assign({}, targetSize);
    const scale = Math.min(targetSize.x / imageSize.x, targetSize.y / imageSize.y);
    return { x: imageSize.x * scale, y: imageSize.y * scale };
};
export const findBestAvailableRegionForNewLogo = (regions, existingLogos = []) => {
    const occupiedRegions = new Set(existingLogos.map(logo => logo.region));
    for (const hierarchyName of REGION_HIERARCHY) {
        const region = regions.find(r => r.name === hierarchyName);
        if (region && !occupiedRegions.has(region.id)) {
            return region;
        }
    }
    return regions.find(r => r.name === 'Chest') || regions[0];
};
export const calculateLogoSizeForRegion = (imageSize, region, is2DProduct) => {
    const targetSize = is2DProduct
        ? { x: region.size.x * 0.25, y: region.size.y * 0.25 }
        : region.size;
    return fit(imageSize, targetSize);
};
export const calculateLogoSizeRetainingWidth = (imageSize, width) => {
    if (imageSize.x === 0) {
        return { x: width, y: width };
    }
    const ratio = imageSize.y / imageSize.x;
    return { x: width, y: width * ratio };
};
